import React, { useState } from "react";
import HoverToDisplayFullTitle from "../../reusableComponents/HoverToDisplayFullTitle";
import { useAuth } from "../../context/API_Client";
import { sortDateTime } from "../utils/utils";
import { customToast } from "../../reusableComponents/customToaster/customToast";
import { Link } from "react-router-dom";
import { RxExternalLink } from "react-icons/rx";
import FileCopyIcon from "../../../assets/svg/fileCopy.svg";
import { colorBrandObject } from "../../../constants/brandings";
import { fileCopyDefaultColor } from "../../reusableComponents/constants";

export function BusinessUnitsSchema(handleEdit, operationPermissions) {
  const { isAuthorizedPermission } = useAuth();
  const copyFunction = ({ value }) => {
    const handleCopy = () => {
      navigator.clipboard.writeText(value);
      customToast("success", "medium", `Copied`);
    };

    return (
      <div
        style={{
          display: "flex",
          marginLeft: "-12px",
          alignItems: "center",
          minWidth: "100px",
          paddingRight: "30px",
        }}
      >
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            flex: 1,
          }}
        >
          {value && <HoverToDisplayFullTitle title={value} len={12} />}
        </div>
        <div style={{ stroke: fileCopyDefaultColor }}>
          <FileCopyIcon
            style={{
              cursor: "pointer",
              position: "absolute",
              right: "0",
              marginRight: "16px",
              top: "50%",
              transform: "translateY(-50%)"
            }}
            onClick={handleCopy}
            stroke={`${colorBrandObject?.actionIconColor}`} />
        </div>
      </div>
    );
  };

  return {
    metadata: {
      title: "Business Units",
      minHeight: "68vh",
      position: "relative",
      showTitle: false,
      rowHeight: 60,
      defaultSortInfo: { name: "addedDTime", dir: -1 },
    },
    fields: [
      {
        name: "name",
        header: "Name",
        visible: true,
        type: "string",
        filtering: false,
        textAlign: "center",
        minWidth: 180,
        defaultFlex: 1,
        sortable: false,

        render: ({ data }) => {
          return (
            <span
              style={{
                marginLeft: "-12px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {data?.name && (
                <HoverToDisplayFullTitle title={data?.name} len={24} />
              )}
            </span>
          );
        },
      },
      {
        name: "code",
        header: "Code",
        visible: true,
        type: "string",
        filtering: false,
        textAlign: "center",
        minWidth: 180,
        defaultFlex: 1,
        sortable: false,
        render: copyFunction,
      },
      {
        name: "addedDTime",
        header: "Created At",
        visible: true,
        type: "datetime",
        filtering: false,
        textAlign: "center",
        minWidth: 200,
        // defaultWidth: 320,
        defaultFlex: 1,
        sort: sortDateTime,
        render: ({ data }) => {
          return (
            <span style={{ display: "flex", marginLeft: "-12px" }}>
              {data?.addedDTime}
            </span>
          );
        },
      },
      {
        name: "websiteAddress",
        header: "Website",
        visible: true,
        type: "String",
        filtering: false,
        textAlign: "center",
        minWidth: 240,
        defaultFlex: 4,
        sortable: false,
        render: ({ data }) => {
          return (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "-12px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              <span
                style={{
                  display: "inline-block",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  minWidth: "200px",
                  maxWidth: "calc(100% - 25px)",
                }}
              >
                {data?.websiteAddress && (
                  <HoverToDisplayFullTitle
                    title={data?.websiteAddress}
                    len={35}
                  >
                    {data?.websiteAddress}
                  </HoverToDisplayFullTitle>
                )}
              </span>
              {data?.websiteAddress && (
                <Link
                  id="website-Link"
                  to={data?.websiteAddress}
                  target="_blank"
                  style={{
                    position: "absolute",
                    right: "8px",
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    paddingLeft: "8px",
                  }}
                >
                  <RxExternalLink
                    style={{
                      width: "24px",
                      height: "16px",
                      cursor: "pointer",
                      color: `${colorBrandObject?.actionIconColor}`
                    }}
                  />
                </Link>
              )}
            </span>
          );
        },
      },
      {
        name: "description",
        header: "Description",
        visible: true,
        type: "string",
        filtering: false,
        minWidth: 200,
        defaultWidth: 180,
        textAlign: "center",
        sortable: false,
        defaultFlex: 4,
        render: ({ data }) => {
          return (
            <span
              style={{
                marginLeft: "-12px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {data?.description && (
                <HoverToDisplayFullTitle title={data?.description} len={32} />
              )}
            </span>
          );
        },
      },

      {
        name: "actions",
        header: "Actions",
        visible: isAuthorizedPermission(operationPermissions?.updateLegalEntity)
          ? true
          : false,
        type: "string",
        filtering: false,
        minWidth: 120,
        defaultFlex: 1,
        textAlign: "center",
        alignItems: "center",
        sortable: false,
        render: ({ data }) => (
          <div
            style={{
              marginLeft: "5px",
              maxWidth: "40px",
            }}
          >
            <div style={{ display: "flex", gap: "8px" }}>
              <img
                src="/assets/routingIcons/Edit-icon.svg"
                className="edit-icon"
                onClick={() => handleEdit(data)}
              />
            </div>
          </div>
        ),
      },
    ],
  };
}
